import { useSelector } from "react-redux";
import _ from "lodash";

import { useInfiniteQueryBuilder, useMutationBuilder, useQueryBuilder } from "../useBuilders";
import {
  EXPERIENCES,
  TEMPLATES,
  FETCH,
  FILTERS,
  UPDATE,
} from "../queryKeys";
import { experiencesTemplatesApi } from "src/services/experiences/templates";
import { StoryboardType } from "src/types/experiences/storyboardSettings/storyboard";

interface UseExperiencesTemplatesParams {
  type: StoryboardType | "";
  category: string;
  industry: string;
  sort: string;
  order: "ASC" | "DESC";
}

const PAGE_SIZE = 20;

export const useExperiencesTemplates = ({
  type,
  category,
  industry,
  sort,
  order,
}: UseExperiencesTemplatesParams) => {
  const superAdmin = useSelector((state: any) =>
    _.get(state, "experiences.workspaces.workspace.item.superAdmin", false),
  );

  return useInfiniteQueryBuilder(
    [EXPERIENCES, TEMPLATES, FETCH, type, category, industry, sort, order],
    ({ pageParam = 0 }) =>
      experiencesTemplatesApi.getTemplates(pageParam, PAGE_SIZE, {
        type,
        category,
        industry,
        sort,
        order,
        superAdmin,
      }),
    0,
    (lastPage) =>
      lastPage.currentPage + 1 < lastPage.totalPages
        ? lastPage.currentPage + 1
        : undefined,
  );
};

export const useExperiencesTemplateFilters = () =>
  useQueryBuilder([EXPERIENCES, TEMPLATES, FILTERS], () =>
    experiencesTemplatesApi.getCategoriesAndIndustries(),
  );

export const useUpdateTemplateVisibility = () =>
  useMutationBuilder(
    [EXPERIENCES, TEMPLATES, UPDATE],
    experiencesTemplatesApi.updateTemplateVisibility,
    [EXPERIENCES, TEMPLATES, FETCH],
  );
